<template>
  <div
    id="form-links"
    class="mb-2"
  >
    <input
      id="user-id"
      type="hidden"
      v-model="link.usuario"
    />
    <input
      id="link-id"
      type="hidden"
      v-model="link.id"
    />
    <input
      id="link-uuid"
      type="hidden"
      v-model="link.uuid"
    />
    <v-row>
      <v-col
        cols="12"
        md="5"
        lg="5"
      >
        <v-text-field
          v-model="link.titulo"
          label="Título"
          outlined
          required
          dense
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="7"
        lg="7"
      >
        <v-text-field
          v-model="link.subtitulo"
          label="Subtítulo"
          outlined
          required
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="6"
      >
        <v-text-field
          v-model="link.link"
          label="Url da página"
          outlined
          required
          dense
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-autocomplete
          v-model="link.target"
          :items="targets"
          clearable
          required
          dense
          outlined
          label="Target"
          :disabled="link_externo === true"
        >
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-autocomplete
          v-model="link.icon_link"
          :items="icons"
          clearable
          required
          dense
          outlined
          label="Ícone do link"
        >
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="3"
        lg="2"
      >
        <v-autocomplete
          v-model="link.uid_local"
          :items="locais"
          required
          dense
          outlined
          label="Local da pagina"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="link.url_imagem"
          label="Url da imagem para card ou botao"
          outlined
          required
          dense
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-text-field
          v-model="link.largura"
          label="Largura imagem"
          outlined
          required
          dense
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-text-field
          v-model="link.altura"
          label="Altura imagem"
          outlined
          required
          dense
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-autocomplete
          v-model="link.posicao"
          :items="posicao"
          clearable
          required
          dense
          outlined
          label="posição imagem"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-checkbox
          v-model="link.botao"
          label="Tipo botão ?"
          color="success"
        >
        </v-checkbox>
      </v-col>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-checkbox
          v-model="link.carde"
          label="Tipo Card ?"
          color="success"
          hide-details
        >
        </v-checkbox>
      </v-col>
      <v-col
        cols="12"
        md="3"
        lg="3"
      >
        <v-text-field
          v-model="link.color"
          type="color"
          label="Cor do card ou botão"
          outlined
          dense
        >
          <v-btn
            class="btn-outer-right pa-0"
            slot="append"
            :color="link.color"
          >
            <v-icon
              large
              class="mx-0"
              :color="link.color ? 'white' : ''"
            >mdi-invert-colors</v-icon>
          </v-btn>
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-text-field
          v-model="link.icon"
          label="icone para card ou botão"
          outlined
          required
          dense
          hint="Exemplo: nome-do-icone"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        lg="2"
      >
        <v-text-field
          v-model="link.color_icon"
          type="color"
          label="Cor do icone"
          outlined
          dense
        >
          <v-btn
            class="btn-outer-right pa-0"
            slot="append"
            :color="link.color_icon"
          >
            <v-icon
              large
              class="mx-0"
              :color="link.color_icon ? 'white' : ''"
            >mdi-invert-colors</v-icon>
          </v-btn>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'FormLinks',
  props: {
    link: { type: Object },
    locais: [],
    link_externo: {},
    codigo: {}
  },
  data: () => ({
    targets: [
      { value: '_top', text: '_top' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    icons: [
      { value: 'pdf', text: 'PDF' },
      { value: 'word', text: 'WORD' },
      { value: 'exel', text: 'EXEL' }
    ],
    posicao: [
      { value: 'L', text: 'Lado direito' },
      { value: 'R', text: 'Lado esquerdo' }
    ]
  }),
  methods: {
    dateB () {
      this.data_criacao = moment(this.date).format('DD/MM/YYYY')
      this.menu1 = false
    },
    mudaData () {
      const [dia, mes, ano] = this.data_criacao.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    }
  }
}
</script>
<style scoped>
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
</style>
